// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-workbook-entries-chunk-group {
  display: table-row-group;
}
.dl-workbook-entries-chunk-group:last-child .dl-content-row:last-child .dl-content-row__content-cell {
  border-bottom: 0;
}
.dl-workbook-entries-chunk-group__hidden-row {
  display: table-row;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/workbooks/components/Table/WorkbookEntriesTable/ChunkGroup/ChunkGroup.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;AACJ;AACI;EACI,gBAAA;AACR;AAEI;EACI,kBAAA;AAAR","sourcesContent":[".dl-workbook-entries-chunk-group {\n  display: table-row-group;\n}\n.dl-workbook-entries-chunk-group:last-child .dl-content-row:last-child .dl-content-row__content-cell {\n  border-bottom: 0;\n}\n.dl-workbook-entries-chunk-group__hidden-row {\n  display: table-row;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
